import { compareDesc } from 'date-fns';

import { ConversationBasic } from '@web/conversations/types/Conversation';

type NameLike = { name: string };
export const filterByName = <T extends NameLike>(name: string, items: T[]): T[] => {
  if (!name) return items;

  const query = name.toLowerCase();

  return items.filter((item) => item.name.toLowerCase().includes(query));
};

type Groups = {
  archived: ConversationBasic[];
  group: ConversationBasic[];
  private: ConversationBasic[];
};
export const groupByType = (conversations: ConversationBasic[]) =>
  conversations.reduce<Groups>(
    (groups, conversation) => {
      if (conversation.isArchived) {
        groups.archived.push(conversation);
      } else if (conversation.isPrivate) {
        groups.private.push(conversation);
      } else {
        groups.group.push(conversation);
      }

      return groups;
    },
    {
      archived: [],
      group: [],
      private: [],
    }
  );

export const orderByImportance = (conversations: ConversationBasic[]) =>
  conversations
    // sort by recent activity
    .sort((a, b) =>
      compareDesc(a.newestUnsilencedMessagePostedAt, b.newestUnsilencedMessagePostedAt)
    )
    // put pinned on top
    .sort((a, b) => +b.isPinned - +a.isPinned);
